jQuery(function($){
    let $block = $('.recycle');
    if ($block.length == 0){
        return;
    }


    // Use the current item as the intersection trigger
    let intersectTrigger = $block[0];  // jQuery object to plain DOM element

    // Function to handle intersections
    function handleIntersect(entries, observer) {
        entries.forEach(entry => {       
            if (entry.isIntersecting) {  
                $block.find('.recycle__arrow').addClass('active');
            }
        });
    }

    // Create a new observer
    const observer = new IntersectionObserver(handleIntersect, {
        root: null, // viewport
        threshold: 0.3
    });

    observer.observe(intersectTrigger);


});